import Reveal from '../../../shared/Reveal/Reveal';
import { useContactSpeakContent } from '../../../../hooks/useContactSpeakContent';
import phoneIcon from '../../../../assets/images/contact/speak/Phone.svg';
import envelopeIcon from '../../../../assets/images/contact/speak/Envelope.svg';
import mainImage from '../../../../assets/images/contact/speak/main.jpg';
import './Speak.css';

const fallbackIcons = [phoneIcon, envelopeIcon];

const Speak = () => {
  const { content, isLoading } = useContactSpeakContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text, items, image } = content;

  return (
    <section className="speak">
      <div className="speak__cream">
        <div className="speak__inner">
          <div className="speak__grid">
            <Reveal className="speak__intro">
              {eyebrow ? <p className="speak__eyebrow">{eyebrow}</p> : null}
              <h2 className="speak__title">{title}</h2>
              {text ? <p className="speak__text">{text}</p> : null}
            </Reveal>

            <Reveal className="speak__details" delay={80}>
              {items.map(({ label, value, href, icon }, index) => (
                <article key={label} className="speak__item">
                  <img
                    className="speak__icon"
                    src={icon || fallbackIcons[index] || phoneIcon}
                    alt=""
                    aria-hidden="true"
                  />
                  <div className="speak__item-copy">
                    <p className="speak__item-label">{label}</p>
                    <a className="speak__item-value" href={href}>
                      {value}
                    </a>
                  </div>
                </article>
              ))}
            </Reveal>
          </div>
        </div>
      </div>

      <div className="speak__white">
        <div className="speak__inner">
          <Reveal className="speak__media">
            <img
              className="speak__image"
              src={image || mainImage}
              alt=""
              aria-hidden="true"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Speak;
